import React, { Component } from 'react'
import css from './styles.scss'
import MacroEnabledContent from '../../MacroEnabledContent'
import ToolTip from '../../ToolTip'

export class Text extends Component {
  constructor ({ string, schema }) {
    super()

    this.state = {
      contents: string || ''
    }
  }

  handleUpdateText = evt => {
    this.setState({
      contents: evt.target.value
    })
  }

  reportContents = templateString => {
    this.props.save(this.props.dataKey, templateString, this.props.idx)
  }

  componentWillReceiveProps (nextProps) {
    const { report, schema } = this.props
    if (nextProps.report === true && report === false && !schema.macroEnabled) {
      this.props.save(this.props.dataKey, this.state.string, this.props.idx)
    }
  }

  updateTemplateString = updatedTemplateString => {
    const { save, dataKey, idx } = this.props
    save(dataKey, updatedTemplateString, idx)
  }

  render () {
    const { contents } = this.state
    const { report, schema, string = '', isSafari, modal, isOption } = this.props
    let inputField = <input type='text' value={contents} onChange={this.handleUpdateText} className={css.input} />
    if (schema.multiline) {
      inputField = <textarea type='text' value={contents} onChange={this.handleUpdateText} className={css.input} rows='2' />
    }
    if (schema.macroEnabled) {
      if (isSafari) {
        inputField = (
          <div className={css.warn}>
            Variable enabled fields are disabled in Safari for OSX. Please use Chrome or Firefox to edit this field
          </div>
        )
      } else {
        inputField = (
          <MacroEnabledContent
            templateString={string}
            updateTemplateString={this.updateTemplateString}
            editorClassName={css.example}
            report={report}
            save={this.reportContents}
            multiLine={schema.multiline}
            modal={modal}
            isOption={isOption}
          />
        )
      }
    }
    return (
      <div className={css.Text}>
        <label className={css.label}>
          <span className={css.schemas}>
            {schema.templates.join(', ')}
          </span>
          {schema.label} <ToolTip tips={schema.description} />
        </label>
        <div className={css.inputField}>
          {inputField}
        </div>
      </div>
    )
  }
}

export default Text



// WEBPACK FOOTER //
// /app/js/components/EditorGUI/Text/index.js